// extracted by mini-css-extract-plugin
export var menuIcon = "_oz-0";
export var menuIconInline = "_oz-1";